module.exports = __webpack_public_path__ + "img/21.5893c9b8.jpg";